<template>
  <div>
    <div
      v-for="(components, componentsIndex) in propsComponentForm"
      :key="componentsIndex"
      class="is-marginless"
    >
      <div>
        <div
          v-if="checkMathIdAll(components) === true || formAction === 'summary'"
        >
          <p
            :id="'M' + components.key"
            v-if="typeof components !== 'undefined'"
            class="is-size-5 th has-text-weight-normal has-text-left"
            :style="indent"
          >
            {{ components.componentName }}
          </p>
          <div v-if="typeof components !== 'undefined'">
            <div
              v-for="(
                component, componentDataIndex
              ) in components.componentData"
              :key="componentDataIndex"
              :style="indent"
            >
              <FormInputData
                v-if="formAction === 'edit'"
                :components="components"
                :component="component"
                :valid="valid"
                :input="input"
                :checkModelValue="checkModelValue"
                :matchId="matchId"
                :checkValidate="checkValidate"
                :checkValidateRequired="checkValidateRequired"
                :checkValidatePhoneNumber="checkValidatePhoneNumber"
                :checkValidateRequiredObject="checkValidateRequiredObject"
                :checkValidateRequiredCheckBox="checkValidateRequiredCheckBox"
                :checkValidateRequiredDes="checkValidateRequiredDes"
                :checkValidateRequiredArrayDes="checkValidateRequiredArrayDes"
                :delInput="delInput"
                :addInput="addInput"
                :componentsIndex="componentsIndex"
                :componentDataIndex="componentDataIndex"
                :inputFormData="inputFormData"
                :checkVarDes="checkVarDes"
                :delFile="delFile"
                :setMatchId="setMatchId"
                :dataKpi="dataKpi"
                :dataInputKpi="dataInputKpi"
                :startupId="startupId"
              />

              <FormViewData
                v-if="formAction === 'view'"
                :component="component"
                :input="input"
                :dataInputKpi="dataInputKpi"
              />
              <FormSummaryData
                v-if="formAction === 'summary'"
                :component="component"
                :dataFormInputAll="dataFormInputAll"
              />
            </div>
          </div>
        </div>
        <div v-if="typeof inputFormComponent[components.key] !== 'undefined'">
          <div
            v-for="(components, componentsIndex) in inputFormComponent[
              components.key
            ]"
            :key="componentsIndex"
          >
            <div
              v-if="
                checkMathIdAll(components) === true || formAction === 'summary'
              "
            >
              <hr
                class="has-text-white-ter"
                :class="{ 'w-80': formAction === 'edit' }"
              />
              <div v-if="formAction === 'edit'" class="has-text-right w-80">
                <a
                  class="is-size-6 has-text-grey-light"
                  @click="delForm(components.key, componentsIndex)"
                >
                  <b-icon pack="fas" icon="times" size="is-small"></b-icon>
                </a>
              </div>
              <div
                v-for="(
                  component, componentDataIndex
                ) in components.componentData"
                :key="componentDataIndex"
                :style="indent"
              >
                <FormInputData
                  v-if="formAction === 'edit'"
                  :components="components"
                  :component="component"
                  :valid="valid"
                  :input="input"
                  :checkModelValue="checkModelValue"
                  :matchId="matchId"
                  :checkValidate="checkValidate"
                  :checkValidateRequired="checkValidateRequired"
                  :checkValidatePhoneNumber="checkValidatePhoneNumber"
                  :checkValidateRequiredObject="checkValidateRequiredObject"
                  :checkValidateRequiredCheckBox="checkValidateRequiredCheckBox"
                  :checkValidateRequiredDes="checkValidateRequiredDes"
                  :checkValidateRequiredArrayDes="checkValidateRequiredArrayDes"
                  :delInput="delInput"
                  :addInput="addInput"
                  :componentsIndex="componentsIndex"
                  :componentDataIndex="componentDataIndex"
                  :inputFormData="inputFormData"
                  :checkVarDes="checkVarDes"
                  :delFile="delFile"
                  :setMatchId="setMatchId"
                  :dataInputKpi="dataInputKpi"
                  :startupId="startupId"
                />

                <FormViewData
                  v-if="formAction === 'view'"
                  :component="component"
                  :input="input"
                  :dataInputKpi="dataInputKpi"
                />
                <FormSummaryData
                  v-if="formAction === 'summary'"
                  :component="component"
                  :dataFormInputAll="dataFormInputAll"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          components.addComponent === true &&
          checkMathIdAll(components) === true &&
          formAction === 'edit'
        "
        class="pd-y-5 has-text-centered w-80"
      >
        <a
          class="is-size-6 is-flex is-align-center is-justify-center"
          @click="addForm(components)"
        >
          <b-icon
            pack="fas"
            icon="plus"
            size="is-small"
            class="mg-x-5"
          ></b-icon>
          {{ $t("message.btnAddMore") }}
        </a>
      </div>

      <FormInput
        v-if="
          typeof components !== 'undefined' && components.children.length > 0
        "
        :propsComponentForm="components.children"
        :stepIndex="stepIndex"
        :depth="depth + 1"
        :validPorps="valid"
        :inputValue="input"
        :formId="formId"
        :formType="formType"
        :compeleteKey="compeleteKey"
        :compeleteFormData="compeleteFormData"
        :checkVarDes="checkVarDes"
        :checkModelValue="checkModelValue"
        :matchId="matchId"
        :inputFormData="inputFormData"
        :addInput="addInput"
        :delInput="delInput"
        :addForm="addForm"
        :delForm="delForm"
        :inputFormComponent="inputFormComponent"
        :dataKpi="dataKpi"
        :dataInputKpi="dataInputKpi"
        :startupId="startupId"
        :batchId="batchId"
        :demo="demo"
        :setMatchId="setMatchId"
        :formAction="formAction"
        :dataFormInputAll="dataFormInputAll"
      />
      <div class="columns is-marginless m-h-auto pd-y-5">
        <div
          v-if="depth === 0 && demo === false && formAction === 'edit'"
          class="column is-12 has-text-centered"
        >
          <a
            @click="saveDataStep()"
            class="button btn-form-add th"
            id="form-save"
          >
            {{ $t("message.btnSave") }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { HTTP, HTTPDynamic } from "@/axios.js";
import FieldUpload from "./FieldUpload";
import DatePicker from "vue2-datepicker";
import FormInputData from "./FormInputData";
import FormViewData from "./FormViewData";
import FormSummaryData from "./FormSummaryData";

export default {
  name: "FormInput",
  components: {
    FieldUpload,
    DatePicker,
    FormInputData,
    FormViewData,
    FormSummaryData,
  },
  props: [
    "propsComponentForm",
    "stepIndex",
    "depth",
    "validPorps",
    "inputValue",
    "formId",
    "formType",
    "compeleteKey",
    "compeleteFormData",
    "checkVarDes",
    "checkModelValue",
    "fetchDataForm",
    "matchId",
    "setMatchId",
    "addInput",
    "inputFormData",
    "delInput",
    "addForm",
    "inputFormComponent",
    "delForm",
    "dataKpi",
    "dataInputKpi",
    "startupId",
    "batchId",
    "demo",
    "formAction",
    "dataFormInputAll",
  ],
  data() {
    return {
      input: {},
      valid: {},
      delFile: [],
    };
  },
  created() {
    this.valid = this.validPorps;
    this.input = this.inputValue;
  },
  computed: {
    indent() {
      return { paddingLeft: `${this.depth * 20}px` };
    },
    getCountryDynamic() {
      return this.$store.getters.getCountryDynamic;
    },
    getProvinceDynamic() {
      return this.$store.getters.getProvinceDynamic;
    },
    token() {
      return this.$store.state.token;
    },
    tokenForm() {
      return this.$store.state.tokenForm;
    },
  },
  methods: {
    regxValidate(allowEng, allowThai, specialChar, integer) {
      // console.log("allowEng",allowEng,"allowThai",allowThai,"specialChar",specialChar,"integer",integer)
      let regx = /^[\w\W]+$/i;
      if (
        allowEng === true &&
        allowThai === true &&
        specialChar === true &&
        integer === true
      ) {
        regx = /^[\w\W]+$/i;
        //เอาทุกตัว
      } else if (
        allowEng === true &&
        allowThai === true &&
        specialChar === true &&
        integer === false
      ) {
        regx = /^[^\d]+$/i;
        //ไม่เอาตัวเลข
      } else if (
        allowEng === true &&
        allowThai === true &&
        specialChar === false &&
        integer === true
      ) {
        regx = /^[\wก-๙]+$/i;
        //ไม่เอาตัวอักษรพิเศษ
      } else if (
        allowEng === true &&
        allowThai === true &&
        specialChar === false &&
        integer === false
      ) {
        regx = /^[a-zA-Zก-๙]+$/i;
        //ไม่เอาตัวอักษรพิเศษและตัวเลข
      } else if (
        allowEng === true &&
        allowThai === false &&
        specialChar === true &&
        integer === true
      ) {
        regx = /^[^ก-๙]+$/i;
        //ไม่เอาภาษาไทย
      } else if (
        allowEng === true &&
        allowThai === false &&
        specialChar === true &&
        integer === false
      ) {
        regx = /^[^ก-๙^0-9]+$/i;
        //ไม่เอาภาษาไทยกับตัวเลข
      } else if (
        allowEng === true &&
        allowThai === false &&
        specialChar === false &&
        integer === true
      ) {
        regx = /^[a-zA-Z0-9]+$/i;
        //เอาแต่ภาษาอังกฤษและตัวเลข
      } else if (
        allowEng === true &&
        allowThai === false &&
        specialChar === false &&
        integer === false
      ) {
        regx = /^[a-zA-Z]+$/i;
        //เอาแต่ภาษาอังกฤษ
      } else if (
        allowEng === false &&
        allowThai === true &&
        specialChar === true &&
        integer === true
      ) {
        regx = /^[^a-z^A-Z]+$/i;
        //ไม่เอาภาษาอังกฤษ
      } else if (
        allowEng === false &&
        allowThai === true &&
        specialChar === true &&
        integer === false
      ) {
        regx = /^[^a-z^A-Z^0-9]+$/i;
        //ไม่เอาภาษาอังกฤษและตัวเลข
      } else if (
        allowEng === false &&
        allowThai === true &&
        specialChar === false &&
        integer === true
      ) {
        regx = /^[ก-๙0-9]+$/i;
        //ไม่เอาภาษาอังกฤษและตัวอักษรพิเศษ
      } else if (
        allowEng === false &&
        allowThai === true &&
        specialChar === false &&
        integer === false
      ) {
        regx = /^[ก-๙]+$/i;
        //เอาแต่ภาษาไทย
      } else if (
        allowEng === false &&
        allowThai === false &&
        specialChar === true &&
        integer === true
      ) {
        regx = /^[^a-z^A-Z^ก-์]+$/i;
        //เอาแต่ตัวอักษรพิเศษและตัวเลข
      } else if (
        allowEng === false &&
        allowThai === false &&
        specialChar === true &&
        integer === false
      ) {
        regx = /^[^a-z^A-Z^ก-๙^0-9]+$/i;
        //เอาแต่ตัวอักษรพิเศษ
      } else if (
        allowEng === false &&
        allowThai === false &&
        specialChar === false &&
        integer === true
      ) {
        regx = /^[๐-๙0-9]+$/i;
        //เอาแต่ตัวเลข
      } else if (
        allowEng === false &&
        allowThai === false &&
        specialChar === false &&
        integer === false
      ) {
        regx = /^[^\w\W]+$/i;
        //ไม่เอาซักตัว
      } else {
        regx = /^[\w\W]+$/i;
      }

      return regx;
    },
    checkValidate(name, validation) {
      let res = false;
      if (validation.required === true) {
        if (this.input[name] !== "" && this.input[name] !== null) {
          let regx = this.regxValidate(
            validation.allowEng,
            validation.allowThai,
            validation.specialChar,
            validation.integer
          );
          res = regx.test(this.input[name]) === true ? false : true;
        } else {
          res = true;
        }
      } else {
        if (this.input[name] !== "" && this.input[name] !== null) {
          let regx = this.regxValidate(
            validation.allowEng,
            validation.allowThai,
            validation.specialChar,
            validation.integer
          );
          res = regx.test(this.input[name]) === true ? false : true;
        }
      }

      let obj = this.valid;
      obj[name]["valid"] = res;
      this.valid = Object.assign({}, this.valid, obj);
    },
    checkValidateRequired(name, validation) {
      let res = false;

      if (validation === true) {
        if (
          this.input[name] !== "" &&
          this.input[name] !== null &&
          this.input[name].length !== 0
        ) {
          res = false;
        } else {
          res = true;
        }
      }
      let obj = this.valid;
      obj[name]["valid"] = res;
      this.valid = Object.assign({}, this.valid, obj);
    },
    checkValidatePhoneNumber(name, validation) {
      let res = false;

      if (validation === true) {
        if (
          typeof this.input[name].countryCode !== "undefined" &&
          typeof this.input[name].value !== "undefined" &&
          this.input[name].countryCode !== "" &&
          this.input[name].countryCode !== null &&
          this.input[name].value !== "" &&
          this.input[name].value !== null &&
          this.input[name].isValid === true
        ) {
          res = false;
        } else {
          res = true;
        }
      }
      let obj = this.valid;
      obj[name]["valid"] = res;
      this.valid = Object.assign({}, this.valid, obj);
    },
    checkValidateRequiredObject(name, validation) {
      let res = false;
      if (validation === true) {
        if (
          this.input[name].data !== "" &&
          this.input[name].data !== null &&
          this.input[name].length !== 0
        ) {
          res = false;
        } else {
          res = true;
        }
      }
      let obj = this.valid;
      obj[name]["valid"] = res;
      this.valid = Object.assign({}, this.valid, obj);
    },
    checkValidateRequiredCheckBox(name, validation) {
      let res = false;
      if (validation === true) {
        if (
          this.checkModelValue[name] !== "" &&
          this.checkModelValue[name] !== null &&
          this.checkModelValue[name].length !== 0
        ) {
          res = false;
        } else {
          res = true;
        }
      }

      let obj = this.valid;
      obj[name]["valid"] = res;
      this.valid = Object.assign({}, this.valid, obj);
    },
    checkValidateRequiredDes(name, valid, validation) {
      let res = false;
      if (validation === true) {
        if (
          typeof this.input[name]["des"] !== "undefined" &&
          this.input[name]["des"] !== null &&
          this.input[name]["des"] !== ""
        ) {
          res = false;
        } else {
          res = true;
        }
      }

      let obj = this.valid;

      obj[valid]["valid"] = res;
      this.valid = Object.assign({}, this.valid, obj);
    },
    checkValidateRequiredArrayDes(
      name,
      label,
      input,
      indexValid,
      valid,
      validation
    ) {
      let res = false;
      if (validation === true) {
        if (
          typeof this.checkVarDes[name + indexValid].des !== "undefined" &&
          this.checkVarDes[name + indexValid].des !== null &&
          this.checkVarDes[name + indexValid].des !== ""
        ) {
          res = false;
        } else {
          res = true;
        }
      }

      let obj = this.valid;
      obj[valid]["valid"] = res;
      this.valid = Object.assign({}, this.valid, obj);
    },
    async saveDataStep() {
      if (typeof this.$tours["tourForm"] !== "undefined") {
        this.$tours["tourForm"].stop();
      }
      let valid = [];
      Object.keys(this.valid).forEach((key) => {
        if (
          this.valid[key].type === "text" ||
          this.valid[key].type === "textarea"
        ) {
          this.checkValidate(this.valid[key].name, this.valid[key].validation);
          let check =
            this.valid[key].valid === true && this.valid[key].hidden === false
              ? 0
              : 1;
          valid.push(check);
        } else if (
          this.valid[key].type === "select" &&
          this.input[key] !== null &&
          typeof this.input[key].countryCode !== "undefined"
        ) {
          this.checkValidatePhoneNumber(
            this.valid[key].name,
            this.valid[key].validation.required
          );
          let check =
            this.valid[key].valid === true && this.valid[key].hidden === false
              ? 0
              : 1;
          valid.push(check);
        } else if (this.valid[key].type === "radio") {
          this.checkValidateRequiredObject(
            this.valid[key].name,
            this.valid[key].validation.required
          );
          let check =
            this.valid[key].valid === true && this.valid[key].hidden === false
              ? 0
              : 1;
          valid.push(check);
        } else if (this.valid[key].type === "radioDes") {
          if (
            this.input[this.valid[key].name].data !== null &&
            this.input[this.valid[key].name].data.userValue === true
          ) {
            this.checkValidateRequiredDes(
              this.valid[key].name,
              this.valid[key].name +
                "UserValue" +
                this.input[this.valid[key].name].data.index,
              true
            );
            let check =
              this.valid[
                this.valid[key].name +
                  "UserValue" +
                  this.input[this.valid[key].name].data.index
              ].valid === true &&
              this.valid[
                this.valid[key].name +
                  "UserValue" +
                  this.input[this.valid[key].name].data.index
              ].hidden === false
                ? 0
                : 1;

            valid.push(check);
          }
        } else if (this.valid[key].type === "checkBoxDes") {
          for (
            let index = 0;
            index < this.checkModelValue[this.valid[key].name].length;
            index++
          ) {
            if (
              this.checkModelValue[this.valid[key].name][index].userValue ===
              true
            ) {
              if (typeof this.checkModelValue !== "undefined") {
                this.checkValidateRequiredArrayDes(
                  this.valid[key].name,
                  this.checkModelValue[this.valid[key].name][index].label,
                  this.checkVarDes[
                    this.valid[key].name +
                      this.checkModelValue[this.valid[key].name][index].index
                  ].des,
                  this.checkModelValue[this.valid[key].name][index].index,
                  this.valid[key].name +
                    "UserValue" +
                    this.checkModelValue[this.valid[key].name][index].index,
                  true
                );
                let check =
                  this.valid[
                    this.valid[key].name +
                      "UserValue" +
                      this.checkModelValue[this.valid[key].name][index].index
                  ].valid === true &&
                  this.valid[
                    this.valid[key].name +
                      "UserValue" +
                      this.checkModelValue[this.valid[key].name][index].index
                  ].hidden === false
                    ? 0
                    : 1;

                valid.push(check);
              }
            }
          }
        } else if (this.valid[key].type === "checkbox") {
          this.checkValidateRequiredCheckBox(
            this.valid[key].name,
            this.valid[key].validation.required
          );
          let check =
            this.valid[key].valid === true && this.valid[key].hidden === false
              ? 0
              : 1;
          valid.push(check);

          this.input[this.valid[key].name] = [];
          for (
            let index = 0;
            index < this.checkModelValue[this.valid[key].name].length;
            index++
          ) {
            let des = null;

            if (
              typeof this.checkVarDes[
                this.valid[key].name +
                  this.checkModelValue[this.valid[key].name][index].index
              ] !== "undefined"
            ) {
              des =
                this.checkVarDes[
                  this.valid[key].name +
                    this.checkModelValue[this.valid[key].name][index].index
                ].des;
            }

            this.input[this.valid[key].name].push({
              value: this.checkModelValue[this.valid[key].name][index].value,
              label: this.checkModelValue[this.valid[key].name][index].label,
              userValue:
                this.checkModelValue[this.valid[key].name][index].userValue,
              index: this.checkModelValue[this.valid[key].name][index].index,
              des: des,
            });
          }
        } else {
          this.checkValidateRequired(
            this.valid[key].name,
            this.valid[key].validation.required
          );
          let check =
            this.valid[key].valid === true && this.valid[key].hidden === false
              ? 0
              : 1;
          valid.push(check);
        }
      });

      if (Math.min(...valid) > 0) {
        let complete = [];
        complete = this.compeleteFormData;

        for (let x = 0; x < this.compeleteKey.length; x++) {
          let data = this.compeleteFormData.filter(
            (item) => item === this.compeleteKey[x]
          );
          if (data.length === 0) {
            complete.push(this.compeleteKey[x]);
          }
        }

        let arr = [];

        let dataForm = {
          input: this.input,
          complete: complete,
          inputAdd: this.inputFormData,
          inputForm: this.inputFormComponent,
        };

        let data = {
          componentId: this.formId,
          data: dataForm,
          companyId: this.startupId,
          roleId: this.batchId,
          keyRequest: this.tokenForm,
        };
        //console.log("create/data/form/prod", data);
        HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.tokenForm}`;
        HTTPDynamic.post(`create/data/form/prod`, data)
          .then((res) => {
            //console.log("create/data/form/prod", res);
            if (res.data.success) {
              if (
                typeof this.dataKpi !== "undefined" &&
                typeof this.dataInputKpi !== "undefined" &&
                Object.values(this.dataInputKpi).length !== 0
              ) {
                this.saveKpi();
              }

              if (this.delFile.length > 0) {
                this.delFileUpload();
              }

              this.$buefy.dialog.alert({
                message:
                  '<p class="has-text-centered is-size-5">บันทึกข้อมูลเรียบร้อยแล้ว</p>',
                onConfirm: () => {
                  this.$emit("fetchDataForm");
                  if (
                    this.compeleteFormData.length === 0 &&
                    typeof this.$tours["tourForm"] !== "undefined"
                  ) {
                    setTimeout(() => {
                      this.$tours["tourForm"].start(4);
                    }, 1000);
                  }
                },
              });
            } else {
              this.$buefy.dialog.alert({
                message:
                  '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่</p>',
                onConfirm: () => {
                  this.$emit("fetchDataForm");
                  if (
                    this.compeleteFormData.length === 0 &&
                    typeof this.$tours["tourForm"] !== "undefined"
                  ) {
                    setTimeout(() => {
                      this.$tours["tourForm"].start(4);
                    }, 1000);
                  }
                },
              });
            }
          })
          .catch((e) => {
            console.log("create/data/form/error", e);
            this.$buefy.dialog.alert({
              message:
                '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>',
              onConfirm: () => {
                this.$emit("fetchDataForm");
                if (
                  this.compeleteFormData.length === 0 &&
                  typeof this.$tours["tourForm"] !== "undefined"
                ) {
                  setTimeout(() => {
                    this.$tours["tourForm"].start(4);
                  }, 500);
                }
              },
            });
          });
      } else {
        this.$emit("setRenderComponent", false);
        console.log("this.compeleteFormData", this.compeleteFormData);
        this.$buefy.dialog.alert({
          message:
            '<p class="has-text-centered is-size-5">กรุณากรอกข้อมูลให้ครบถ้วน</p>',
          onConfirm: () => {
            if (
              this.compeleteFormData.length === 0 &&
              typeof this.$tours["tourForm"] !== "undefined"
            ) {
              setTimeout(() => {
                this.$tours["tourForm"].start(3);
              }, 500);
            }
          },
        });
      }
    },
    saveKpi() {
      let kpiData = {};

      Object.keys(this.input).forEach((key) => {
        if (typeof this.dataInputKpi[key] !== "undefined") {
          kpiData[key] = {
            type: this.dataInputKpi[key].type,
            input: this.input[key],
            lastUpdate: new Date(),
            repeat: this.dataInputKpi[key].repeat,
            nameLabel: this.dataInputKpi[key].nameLabel,
          };
        }
      });

      Object.keys(this.dataKpi).forEach((key) => {
        if (typeof kpiData[key] === "undefined") {
          kpiData[key] = {
            type: this.dataKpi[key].type,
            input: this.dataKpi[key].input,
            lastUpdate: new Date(this.dataKpi[key].lastUpdate),
            repeat: this.dataKpi[key].repeat,
            nameLabel: this.dataKpi[key].nameLabel,
          };
        }
      });

      let data = {
        componentId: this.formId,
        companyId: this.startupId,
        roleId: this.batchId,
        kpi: kpiData,
      };
      //console.log("api/add/kpi/res", data);
      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTPDynamic.post(`api/add/kpi`, data)
        .then((res) => {
          //console.log("api/add/kpi", res);
        })
        .catch((e) => {
          console.log("api/add/kpi/error", e);
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
    },
    delFileUpload() {
      const data = {
        files: this.delFile,
      };

      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTPDynamic.post(`delete/file`, data)
        .then((res) => {
          //console.log("delete/file", res);
          if (res.data.success) {
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่</p>'
            );
          }
        })
        .catch((e) => {
          console.log("delete/file/error", e);
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
    },
    checkMathIdAll(components) {
      let check = [];

      if (components.componentData.length > 0) {
        for (let index in components.componentData) {
          if (
            typeof components.componentData[index].display.matchid !==
              "undefined" &&
            typeof components.componentData[index].display.matchid !== null &&
            typeof components.componentData[index].display.matchid !== ""
          ) {
            let math =
              this.checkMathId(
                components.componentData[index].display.matchid,
                this.matchId
              ) === true
                ? 1
                : 0;
            check.push(math);
          } else {
            check.push(1);
          }
        }
      } else {
        check.push(1);
      }
      if (Math.max(...check) > 0) {
        return true;
      } else {
        return false;
      }
    },
    checkMathId(matchid, displaymatchid) {
      if (
        typeof displaymatchid !== "undefined" &&
        Object.values(displaymatchid).length > 0 &&
        typeof matchid !== "undefined"
      ) {
        let data = [];
        Object.keys(displaymatchid).forEach((key) => {
          if (displaymatchid[key] === matchid) {
            data.push(displaymatchid[key]);
          }
        });

        return matchid === "" || data.length > 0;
      }
      return true;
    },
  },
};
</script>
<style scoped>
.mw-500 {
  min-width: 500px !important;
}
.btn-form-add {
  min-width: 130px;
  min-height: 40px;
  border: 1px solid #6d8df3;
  color: #6d8df3;
  margin: 5px;
}
</style>
